module.exports = __webpack_public_path__ + "img/Fs_Banner.8a424d33.png";